import React from 'react'
import {Link, useLocation} from 'react-router-dom'
import PlusWhite from './svg/PlusWhite'
import Logo from './svg/Logo'

function Navigation() {
    const location = useLocation()
    const current_pathname = location.pathname
    const isCreateStartupPage = current_pathname.startsWith('/create-startup')

    return (
        <div className="w-full topbar-navigation">
            <ul className="topbar-link">
                <a href="https://station-frankfurt.de/">
                    <li className="topbar-link-logo">
                        <Logo/>
                    </li>
                </a>
                <Link to="/create-startup">
                    <li
                        className={
                            isCreateStartupPage
                                ? 'hidden topbar-link-secondary md:inline flex-row items-center'
                                : 'topbar-link-primary flex flex-row items-center'
                        }>
                        <PlusWhite
                            fill={
                                isCreateStartupPage
                                    ? 'white'
                                    : 'black'
                            }
                        />
                        <span className="ml-2">Register <span className="hidden sm:inline">Startup</span></span>
                    </li>
                </Link>
                <Link to="/" className="">
                    <li
                        className={
                            isCreateStartupPage
                                ? 'topbar-link-primary'
                                : 'hidden lg:inline topbar-link-secondary'
                        }>
                        Find a Startup
                    </li>
                </Link>
            </ul>
        </div>
    )
}

export default Navigation
